export default __webpack_public_path__ + "static/media/All-included.edbeac9c.jpg";